import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { DATE_FORMATS_FNS, useSelectedLocation } from "components";
import { createFormHelper } from "lib/Form";
import { FIXED_VIN_LENGTH } from "modules/Appointments/components/NewAppointment/utils";
import { isKeyLoopLocation } from "utils/common";
import { formatDate } from "utils/dateHelperFunctions";

import type { AppointmentSection } from "modules/Appointments/components/NewAppointment";

type CarFormSectionProps = {
  hasErrors: boolean;
  carFromExternalData: boolean;
  lastSelectedTitle: string;
};

const FormHelper = createFormHelper<AppointmentSection>();

export const CarFormSection = ({ hasErrors, carFromExternalData, lastSelectedTitle }: CarFormSectionProps) => {
  const { t } = useTranslation();

  const { selectedLocation } = useSelectedLocation();
  const { formState, watch } = FormHelper.useFormContext();
  const [regNr, make, model, vin, apkDate] = watch(["car.reg_nr", "car.make", "car.model", "car.vin_nr", "car.apk_date_dms"]);

  const keyloopLocation = isKeyLoopLocation(selectedLocation);

  return (
    <Form loading={formState.isSubmitting} disabled={formState.isSubmitting} style={{ padding: "0 23px" }}>
      <Grid columns="equal">
        <GridColumn>
          <Form.Field required error={hasErrors && !regNr}>
            <label> {t("v8_registration", "Registration")} </label>
            <FormHelper.Field.Input
              name="car.reg_nr"
              inputProps={{ placeholder: t("v8_registration", "Registration"), fluid: true, disabled: !!lastSelectedTitle || carFromExternalData }}
            />
          </Form.Field>
        </GridColumn>
        <GridColumn>
          <Form.Field required error={hasErrors && !make}>
            <label> {t("v8_make", "Make")} </label>
            <FormHelper.Field.Input name="car.make" inputProps={{ placeholder: t("v8_make", "Make"), fluid: true }} />
          </Form.Field>
        </GridColumn>
        <GridColumn>
          <Form.Field required error={hasErrors && !model}>
            <label> {t("v8_model", "Model")} </label>
            <FormHelper.Field.Input name="car.model" inputProps={{ placeholder: t("v8_model", "Model"), fluid: true }} />
          </Form.Field>
        </GridColumn>
      </Grid>
      <Grid columns="equal">
        <GridColumn>
          <Form.Field>
            <label> {t("v8_apk_date", "APK date")} </label>
            <FormHelper.Field.Input
              name="car.apk_date_dms"
              inputProps={{ placeholder: t("v8_apk_date", "APK date"), value: formatDate(apkDate, DATE_FORMATS_FNS.dateMonthYear), fluid: true, disabled: true }}
            />
          </Form.Field>
        </GridColumn>
        <GridColumn>
          <Form.Field required={keyloopLocation} error={keyloopLocation && hasErrors && (!vin || vin.trim().length !== FIXED_VIN_LENGTH)}>
            <label> {t("v8_vin", "Vin")} </label>
            <FormHelper.Field.Input name="car.vin_nr" inputProps={{ placeholder: t("v8_vin", "Vin"), fluid: true }} />
          </Form.Field>
        </GridColumn>
      </Grid>
    </Form>
  );
};
